











































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  getdatalist,
  addratsheet,
  getdatainfo,
  changedatainfo,
  getAnalizelist,
  getdetail,
  upLoadFile,
  getinjurylist,
  removelotData,
  getorgytype,
} from "@/api/ratsheetmanage";

@Component({
  name: "adminManage",
  components: { Pagination },
})
export default class extends Vue {
  [x: string]: any;
  mounted() {
    this.getlist(this.listQuery);
    this.getinjurylist();
    this.addParms.orginizeid = this.getsession().orgnizeid;
    this.addParms.userid = this.getsession().userid;
    this.userid = this.getsession().userid;
    this.listQuery.organid = this.getsession().orgnizeid;
    this.getratescale();
  }
  private userid = "";
  private tableData: Array<any> = []; //表格数据
  private uploadfileloading = false;
  private diatableData: Array<any> = []; //统计表格数据
  private coreItems: any = []; //统计页面考核细则
  private total: number = 0;
  private diatotal: number = 0;
  private loading = true;
  private isloading = true;
  private showStyle = {};
  private rashttype = "";
  // 分页请求参数
  private listQuery = {
    organid: "",
    name: "",
    page: 1,
    limit: 10,
  };
  private options = [
    {
      key: "启用",
      value: 1,
    },
    {
      key: "禁用",
      value: 0,
    },
  ];
  private isue = 1;
  //添加表单参数
  // private addParms: any = {
  //   injurytypeid: "",
  //   totalscore: "",
  //   totaltime: "",
  //   timestate: 1,
  //   isuse: "",
  //   timeoutbase: "",
  //   reducebase: "",
  //   name: "",
  //   content: [
  //     {
  //       levelonetitle: "",
  //       levelonesort: "",
  //       leveltwolist: [
  //         { conts: "", score: "", leveltwosort: "", contsdescribe: "" },
  //       ],
  //     },
  //   ],
  // };
  //添加表单参数
  private detail: any = {
    injurename: {
      labe: "",
    },
    id: "",
    name: "",
    content: [
      {
        levelonetitle: "",
        levelonesort: "",
        leveltwolist: [
          {
            conts: "",
            score: "",
            leveltwosort: "",
            timestate: 1,
            time: "",
            contsdescribe: "",
            timeoutbase: "",
            reducebase: "",
          },
        ],
      },
    ],
  }; //查看详情绑定的数据源
  private addParms: any = {
    injurytypeid: "",
    orginizeid: "",
    ratescale: "",
    isuse: "",
    userid: "",
    name: "",
    content: [
      {
        levelonetitle: "",
        levelonesort: "",
        leveltwolist: [
          {
            id: "",
            conts: "",
            score: "",
            leveltwosort: "",
            timestate: 1,
            time: "",
            contsdescribe: "",
            timeoutbase: "",
            reducebase: "",
          },
        ],
      },
    ],
  };
  private editParms: any = {
    id: "",
    isuse: "",
    orginizeid: "",
    isdelete: "",
    injurytypeid: "",
    name: "",
    content: [
      {
        id: "",
        levelonetitle: "",
        levelonesort: "",
        leveltwolist: [
          {
            id: "",
            conts: "",
            score: "",
            leveltwosort: "",
            timestate: 1,
            time: "",
            totaltime: "",
            contsdescribe: "",
            timeoutbase: "",
            reducebase: "",
          },
        ],
      },
    ],
  };
  private uploadParms: any = {
    region: "",
  };
  private injurylist: any = [];

  // 批量删除的id
  private idlist: any = [];
  private uploadfile = []; //上传文件得内容
  private fileSizeIsSatisfy = [];
  private multipleSelection: any = [];
  // 统计表的参数
  private listTableQuery: any = {
    id: "",
    name: "",
    pages: 1,
    limit: 10,
    begintime: null,
    endtime: null,
    timetype: "",
  };
  //模态框参数
  private diaparms = {
    dialogVisible: false,
    tabledia: false,
    scoredia: false,
    disibleState: false,
    detailVisible: false,
    title: "",
    type: "",
  };

  // 校验规则
  private rules = {
    // title: [{ required: true, message: "请输入总计时", trigger: "blur" }],
    name: [{ required: true, message: "请输入评估标准名称", trigger: "blur" }],

    region: [{ required: true, message: "请选择伤情类型", trigger: "change" }],
    totalscore: [
      { required: true, message: "总分不能为空" },
      { type: "number", message: "总分必须为数字值" },
    ],
    totaltime: [
      { required: true, message: "计时不能为空" },
      { type: "number", message: "计时为数字" },
      {
        pattern: /^\d{1,3}$/,
        message: "长度在1-1000范围内(秒)",
        trigger: "blur",
      },
    ],
    injurytitle: [
      { required: true, message: "请输入标题名称", trigger: "blur" },
    ],
  };

  private searchData() {
    this.getlist(this.listQuery);
  }
  private async searchdiaData() {
    if (this.listTableQuery.timetype != "") {
      if (
        this.listTableQuery.begintime == null ||
        this.listTableQuery.endtime == null
      ) {
        this.$message({
          message: "请选择起始和结束时间",
          type: "warning",
        });
      } else {
        this.getStatistics(this.listTableQuery);
      }
    } else {
      this.listTableQuery.begintime = null;
      this.listTableQuery.endtime = null;
      this.getStatistics(this.listTableQuery);
    }
  }
  private clearSearch() {
    this.listQuery = {
      name: "",
      page: 1,
      limit: 10,
      organid: "",
    };

    this.getlist(this.listQuery);
  }
  private cleardiaSearch() {
    this.listTableQuery.name = "";
    this.listTableQuery.pages = 1;
    this.listTableQuery.limit = 10;
    this.listTableQuery.begintime = null;
    this.listTableQuery.endtime = null;
    this.listTableQuery.timetype = "";
    this.isactive = 4;
    this.getStatistics(this.listTableQuery);
  }
  // 获取当前组织的pid 判断是否是学校管理员 设置评分表类型 暂定pid=-1是最高组织
  private async getratescale() {
    let orgarr = this.getsession().orgnizeid.split(",");
    let orgid_parm;
    if (orgarr.length > 1) {
      orgid_parm = {
        id: orgarr.pop().toString(),
      };
    } else {
      orgid_parm = {
        id: orgarr.pop().toString(),
      };
    }
    await getorgytype(orgid_parm).then((res) => {
      if (res.code == 200) {
        this.rashttype = res.data.pid;
      }
    });
  }
  // 获取信息列表
  private async getlist(parm: any) {
    await getdatalist(this.listQuery).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        const resdata = res.data.itemBean;
        resdata.forEach((res: any) => {
          res.isuse = res.isuse == true ? 1 : false;
        });
        this.tableData = resdata;
        this.total = res.data.total;
      }
    });
  }
  // 获取sessionstorage
  private getsession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    return parma;
    // this.addParams.orgnizeid = parma.orgnizeid;
  }
  //新增评估标准
  private async adduser() {
    if (this.rashttype === "-1") {
      this.diaparms.title = "新增通用评估标准";
      this.addParms.ratescale = 1;
    } else {
      this.diaparms.title = "新增自建评估标准";
      this.addParms.ratescale = 2;
    }
    this.diaparms.type = "adduser";
    this.$nextTick(() => {
      (this.$refs.addParms as any).resetFields();
      // this.emptyParams();
    });
    this.diaparms.dialogVisible = true;
  }
  private async submit(type: any) {
    const form = this.$refs.addParms as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        if (this.editParms.id) {
          this.foreachContent(this.editParms);
          this.editParms.isuse = this.isue;
          // console.log(this.editParms);
          await changedatainfo(this.editParms).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              form.resetFields();
              this.diaparms.dialogVisible = false;
              this.getlist(this.listQuery);
            }
          });
        } else {
          this.foreachContent(this.addParms);
          this.addParms.isuse = this.isue;
          console.log(this.addParms);
          await addratsheet(this.addParms).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              form.resetFields();
              this.diaparms.dialogVisible = false;
              this.getlist(this.listQuery);
            }
          });
        }
      }
    });
  }
  // 遍历一级评分项赋排序值
  private foreachContent(params: any) {
    params.content.forEach((res: any, index: any) => {
      res.levelonesort = index;
      res.leveltwolist.forEach((item: any, indexs: any) => {
        item.leveltwosort = indexs;
      });
    });
  }
  // 查看评估标准
  private async watchTrainDetail(parm: any) {
    this.diaparms.detailVisible = true;
    const params = {
      id: parm.id,
    };
    await getdatainfo(params).then((res) => {
      if (res.code === 200) {
        this.detail = res.data;
        this.injurylist.forEach((e) => {
          if (e.id === res.data.injurytypeid) {
            this.detail.injurename = e;
          }
        });
      }
    });
  }
  //编辑用户
  private async editinfo(parm: any) {
    if (this.getsession().usertype === 1 || this.getsession().usertype === 0) {
      this.diaparms.title = "编辑通用评估标准";
      this.addParms.ratescale = 1;
    } else {
      this.diaparms.title = "编辑自建评估标准";
      this.addParms.ratescale = 2;
    }
    this.diaparms.type = "edituser";
    // this.addParms.id = parm.id;
    const params = {
      id: parm.id,
    };
    await getdatainfo(params).then((res) => {
      if (res.code === 200) {
        // res.data.region = res.data.region.split(",");
        this.addParms = res.data;
        this.diaparms.dialogVisible = true;
        this.editParms = res.data;
        this.editParms.isdelete = 1;
      }
    });
  }
  //清空参数
  private emptyParams() {
    this.addParms = {
      injurytypeid: "",
      isuse: "",
      name: "",
      content: [
        {
          levelonetitle: "",
          levelonesort: "",
          leveltwolist: [
            {
              conts: "",
              score: "",
              leveltwosort: "",
              timestate: 1,
              time: "",
              contsdescribe: "",
              timeoutbase: "",
              reducebase: "",
            },
          ],
        },
      ],
    };
    this.editParms = {
      id: "",
      isuse: "",
      isdelete: "",
      injurytypeid: "",
      name: "",
      content: [
        {
          id: "",
          levelonetitle: "",
          levelonesort: "",
          leveltwolist: [
            {
              id: "",
              conts: "",
              score: "",
              leveltwosort: "",
              timestate: 1,
              time: "",
              contsdescribe: "",
              timeoutbase: "",
              reducebase: "",
            },
          ],
        },
      ],
    };
  }

  private changeFocus() {
    if (this.listTableQuery.timetype == "") {
      this.$message({
        message: "请先选择时间粒度",
        type: "warning",
      });
    }
  }
  private starttime = {
    disabledDate: (time: any) => {
      if (this.listTableQuery.endtime) {
        return time.getTime() > new Date(this.listTableQuery.endtime).getTime();
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private endtime = {
    disabledDate: (time: any) => {
      if (this.listTableQuery.begintime) {
        return (
          time.getTime() > Date.now() ||
          time.getTime() < new Date(this.listTableQuery.begintime).getTime()
        );
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private async removelotData() {
    if (this.multipleSelection.length == 0) {
      this.$message({
        type: "warning",
        message: "请先选择要删除的数据",
      });
    } else {
      const param = { id: this.idlist.join(",") };
      await removelotData(param).then((res) => {
        if (res.code === 200) {
          this.$message.success("数据删除成功");
          this.getlist(this.listQuery);
        }
      });
    }
  }
  // 单个删除
  private async removeData(parm: any) {
    const params = {
      id: parm.id,
    };
    await getdatainfo(params).then((res) => {
      if (res.code === 200) {
        this.editParms = res.data;
        this.editParms.isdelete = 0;
        this.$confirm("确认要删除评估标准吗？", "删除评估标准", {
          type: "warning",
        }).then(async () => {
          await changedatainfo(this.editParms).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getlist(this.listQuery);
              // this.emptyParams();
            }
          });
        });
      }
    });
  }

  // 打开统计对话框
  private async analist(parm: any) {
    this.diaparms.tabledia = true;
    this.isactive = 4;
    this.listTableQuery.id = parm.id;
    this.getStatistics(this.listTableQuery);
    this.getStatisticsdetail(this.listTableQuery);
  }
  private exportsheet(val) {
    console.log(val);
    let abtn = document.createElement("a");
    abtn.download = val.name;
    abtn.href =
      "http://192.168.4.10:8081/tellyes/judgementfirst/download?judgeId=" +
      val.id;
    abtn.click();
  }
  //获取统计列表的表格
  private async getStatistics(val: any) {
    await getAnalizelist(val).then((res) => {
      if (res.code === 200) {
        this.diatableData = res.data.items;
        this.diatotal = res.data.total;
      }
    });
  }
  // 获取统计页面右侧项
  private async getStatisticsdetail(val: any) {
    await getdetail(val).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        this.coreItems = res.data;
        // this.coreItems = JSON.parse(res.data.items.injurylist);
      } else if (res.code === 201) {
        this.isloading = false;
        this.$message.warning("当前没有数据");
      }
    });
  }
  // 更改按钮状态
  // private changetage(parm: any) {
  //   //将点击的元素的索引赋值给bian变量
  //   this.listTableQuery.begintime = null;
  //   this.listTableQuery.endtime = null;
  //   if (parm == 0) {
  //     this.listTableQuery.timetype = "week";
  //     this.diaparms.beginType = "开始周";
  //     this.diaparms.endType = "结束周";
  //     this.diaparms.dateText = "yyyy 第 WW 周";
  //   } else if (parm == 1) {
  //     this.listTableQuery.timetype = "month";
  //     this.diaparms.beginType = "开始月";
  //     this.diaparms.endType = "结束月";
  //     this.diaparms.dateText = "";
  //   } else if (parm == 2) {
  //     this.listTableQuery.timetype = "year";
  //     this.diaparms.beginType = "开始年";
  //     this.diaparms.dateText = "";
  //     this.diaparms.endType = "结束年";
  //   }
  //   this.isactive = parm;
  // }
  // 复选框选中
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  // 获取伤情列表
  private async getinjurylist() {
    const params = {
      name: "",
      page: -1,
      limit: 10,
      isuse: 1,
    };
    this.injurylist = [];
    await getinjurylist(params).then((res: any) => {
      if (res.code === 200) {
        const data = res.data.items;
        data.forEach((res: any) => {
          let object: any = {};
          object.id = res.id;
          object.label = res.injurename;
          this.injurylist.push(object);
        });
      }
    });
  }
  // 导入评估标准
  private async insertScore() {
    this.diaparms.scoredia = true;
    this.fileSizeIsSatisfy = [];
    this.uploadParms = { region: "" };
    this.getinjurylist();
  }
  // 导出评估标准
  private exportfile() {
    if (this.multipleSelection.length === 0) {
      this.$message.warning("请选择需要导出得评估标准");
    } else {
      let idarray: any = [];
      this.multipleSelection.forEach((item: any) => {
        idarray.push(item.id);
      });
      const param = {
        idlist: idarray.join(","),
      };
    }
  }
  private addTime() {
    this.addParms.content.push({
      levelonetitle: "",
      levelonesort: "",
      id: "",
      leveltwolist: [
        {
          conts: "",
          score: "",
          leveltwosort: "",
          timestate: 1,
          time: "",
          contsdescribe: "",
          timeoutbase: "",
          reducebase: "",
        },
      ],
    });
    this.editParms.content.push({
      levelonetitle: "",
      levelonesort: "",
      id: "",
      leveltwolist: [
        {
          id: "",
          conts: "",
          score: "",
          leveltwosort: "",
          timestate: 1,
          time: "",
          totaltime: "",
          contsdescribe: "",
          timeoutbase: "",
          reducebase: "",
        },
        ,
      ],
    });
  }
  private addchildtime(arry: any, index: any) {
    arry.push({
      conts: "",
      score: "",
      leveltwosort: "",
      timestate: 0,
      contsdescribe: "",
      timeoutbase: "",
      reducebase: "",
      id: "",
    });
  }
  private reduceTime(index: number) {
    if (this.addParms.content.length === 1) {
      this.$message({
        type: "warning",
        message: "最少输入一条评分项信息",
      });
    } else {
      this.addParms.content.splice(index, 1);
    }

    // .splice(index, 1);
  }
  private redectChild(arry: any, index: any) {
    if (arry.length === 1) {
      this.$message({
        type: "warning",
        message: "最少输入一条二级评分信息",
      });
    } else {
      arry.splice(index, 1);
    }
  }
  private handleExceed(file: any, fileList: any) {
    this.$message.warning(`当前限制上传 3 个文件`);
  }
  private fileOnChange(file: any) {
    let that: any = this;
    that.fileSizeIsSatisfy.push(file.raw);
  }
  private fileBeforeRemove(file: any, fileList: any) {
    this.fileSizeIsSatisfy = fileList;
  }

  // 文件上传方法
  // private fileBeforeUpload(file: any) {
  //   let that: any = this;
  //   that.uploadfile.push(file);
  //   var FileExt = file.name.replace(/.+\./, "");
  //   if (["doc", "xlsx"].indexOf(FileExt.toLowerCase()) === -1) {
  //     this.$message({
  //       type: "warning",
  //       message: "请上传后缀名为doc、xlsx的附件！",
  //     });
  //     return false;
  //   }
  //   return false;
  //   // 返回false，停止上传
  // }
  // 上传文件方法
  private saveForm() {
    const form = this.$refs.ruleForm as any;
    this.uploadfileloading = true;
    form.validate(async (valid: boolean) => {
      if (valid) {
        // // 创建一个formData对象
        const formData = new FormData();
        for (var i = 0; i < this.fileSizeIsSatisfy.length; i++) {
          formData.append("file", this.fileSizeIsSatisfy[i]);
        }
        // 声明orginizeid
        const orgnizeid = this.getsession()
          .orgnizeid.split(",")
          .splice(0, 3)
          .join(",");

        // 上传文件参数
        const userid = this.getsession().userid;
        let ratescale;
        if (this.rashttype === "-1") {
          ratescale = 1;
        } else {
          ratescale = 2;
        }

        formData.append("injurytypeid", this.uploadParms.region);
        formData.append("organid", orgnizeid);
        formData.append("userid", userid);
        formData.append("ratescale", ratescale);
        await upLoadFile(formData).then((res: any) => {
          if (res.code === 200) {
            this.uploadfileloading = false;
            this.$message.success("文件上传成功");

            this.diaparms.scoredia = false;
            (this.$refs.ruleForm as any).resetFields();
            this.getlist(this.listQuery);
          } else if (res.code === 500) {
            this.uploadfileloading = false;
            this.$message.warning(
              "请检查上传文件格式，支持.doc/.xlsx/.xls格式文件"
            );
          }
        });
      } else {
        return false;
      }
    });
  }
  private handleSizeChange(val: any) {
    this.listTableQuery.limit = val;
    this.getStatistics(this.listTableQuery);
  }
  private async handleCurrentChange(val: number) {
    this.listTableQuery.pages = val;
    this.getStatistics(this.listTableQuery);
  }
  // 模态框关闭
  private handleClose(done: any) {
    this.diaparms.dialogVisible = false;
    this.diaparms.tabledia = false;
    this.diaparms.scoredia = false;
    this.diaparms.detailVisible = false;
    // this.$nextTick(() => {
    //   (this.$refs.addParms as any).resetFields();
    // });
  }
  /*
    @params{
      val:二级评分项的索引值
      timestate:二级评分项当前计时绑定值
      index:一级评分项class=main的索引值
    }
  */
  private changeSwitch(val: number, items: any, index: number) {
    // 设置items.timestate v-show控制0隐藏1显示
    if (items.timestate === 1) {
      return items.timestate === 1;
    } else {
      this.$confirm(
        "将清空该二级评分项下得超时基础值，扣分基础值，时长",
        "确定关闭计时状态吗？",
        {
          type: "warning",
        }
      )
        .then((res: any) => {
          this.addParms.content[index].leveltwolist[val].timeoutbase = "";
          this.addParms.content[index].leveltwolist[val].reducebase = "";
          this.addParms.content[index].leveltwolist[val].time = "";
          return (this.addParms.content[index].leveltwolist[val].timestate = 0);
        })
        .catch(() => {
          return (this.addParms.content[index].leveltwolist[val].timestate = 1);
        });
    }
  }
  private async changeSwitchState(parm: any) {
    const params = {
      id: parm.id,
    };
    await getdatainfo(params).then(async (res) => {
      if (res.code === 200) {
        this.editParms = res.data;
        this.editParms.isdelete = 1;
        this.editParms.isuse = parm.isuse;
        await changedatainfo(this.editParms).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: "状态更改成功",
              type: "success",
            });
          }
        });
      }
    });
  }
  // 设置表格字体居中
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
